import jwt_decode from "jwt-decode";
import jwt_encode from "jwt-encode";
import moment from "moment";
import DOMPurify from "dompurify";
import {
  ProductBadgeEnum,
  apiConstants,
  CheckoutInformation,
  PaymentModes,
  environments,
} from "@Constants/constants";
import { useDeviceData } from "react-device-detect";
import { toast } from "react-hot-toast";
import { FilterMapping } from "@Components/UI/filters/constants/filters.constants";
import ReactGA from "react-ga";
import { LocalStorageDataModel } from "@Constants/local-storage-data-model";
import { postData } from "@Src/services/learning/global.service";
import { APIEnv, APIStatus } from "@Src/services/learning/baseInterfaces";
import CryptoJS from "crypto-js";
import { HOME_API_CONSTANTS } from "@Constants/api-constants/home/home.constant";

let userMindlerAuthKey =
  "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImlzbWFpbGtoYW4xM0BtaW5kbGVyLmNvbSIsImF1dGhfaWQiOjI4MjEyNiwiaXNfYWx1bW5pIjoxLCJpYXQiOjE2NTgxMjUwNzV9.oVOXjQdRdwlSQ34vF1yM_lt25XziYDIyFrRYSPKY-cs";

export const encodeString = (value: any) => {
  return jwt_encode(value, Env().JWT_ENCODE_SECRECT || "");
};

export const decodeString = (value: string) => {
  return jwt_decode(value);
};

export const encodeKeyAndUrl = (route: string) => {
  const decodedObj: any = decodeString(userMindlerAuthKey);
  decodedObj["url"] = route;
  return encodeString(decodedObj);
};

export const setDataOnLocalStorage = (key: string, value: string) => {
  return localStorage.setItem(key, value);
};

export const setDataOnLocalStorageWithExpiry = (
  key: string,
  value: any,
  ttl: any
) => {
  const now = new Date();
  const item = {
    value: value,
    expiry: now.getTime() + ttl,
    date: now.toLocaleDateString(),
  };
  return localStorage.setItem(key, JSON.stringify(item));
};

export const checkIsUserLoggedIn = () => {
  return IsLoggedIn();
  // getDataFromLocalStorage("TaxmannAuthorization");
};

export const pushUtmSourceInformation = (
  description: string,
  deleteCampaignAfterPush: boolean = false,
  recordType = "GENERAL",
  data: any = {},
  actionType = "GENERAL"
): void => {
  let campaignName = getDataFromLocalStorage("activeCampaign");
  const { pathname, search } = window.location;
  if (!campaignName) {
    return;
  }
  let userIp = getDataFromLocalStorage(LocalStorageDataModel.USER_IP);
  let campaignUrl = getDataFromLocalStorage("activeCampaignUrl");
  let payload = {
    IpAddress: userIp,
    Action: description,
    CampaignName: campaignName,
    UtmDetails: JSON.parse(getDataFromLocalStorage(campaignName)),
    ComponentUrl: pathname + search,
    CampaignUrl: campaignUrl,
    platform: "taxmann",
    recordType: recordType, // GENERAL, CRM,
    actionType: actionType, // GENERAL, FREE_TRIAL, REQUEST_CALLBACK,
    data: data, // can be as per IUTMDataProps keys,
    UserEmail: getDataFromLocalStorage(LocalStorageDataModel.EMAIL),
    UserName: getDataFromLocalStorage(LocalStorageDataModel.USER_NAME),
  };
  let isLoggedIn = checkIsUserLoggedIn();
  let url = isLoggedIn
    ? "tracking/userActionTracking"
    : "tracking/userActionTracking?verifyToken=NO";
  // console.log("this is url: ", url);
  postData(url, payload, APIEnv.MARKETING)
    .then((res) => {
      // console.log("this is marketing postData: ", res);
      if (res && res.success == true) {
        if (deleteCampaignAfterPush) {
          removeDataFromLocalStorage("activeCampaign");
          removeDataFromLocalStorage(campaignName);
        }
      }
    })
    .catch((err) => {});
};

export const getDataFromLocalStorage = (key: string) => {
  var value = localStorage.getItem(key);
  if (value === null) {
    return "";
  }
  return value;
};

export const removeDataFromLocalStorage = (key: string) => {
  localStorage.removeItem(key);
  return;
};

export const isMobile = () => {
  let mediaQueryObj = window.matchMedia("(max-width: 950px)");
  return mediaQueryObj.matches;
};

export const checkValidFileExtensions = (
  inputFileArray: any[],
  allowedFileExtensions: string[]
): boolean => {
  let isValid = false;
  for (let i = 0; i < allowedFileExtensions.length; i++) {
    const splitArray = inputFileArray[0].name?.split(".");
    if (
      splitArray[splitArray.length - 1]?.toString()?.toLowerCase() ==
      allowedFileExtensions[i]?.toString()?.toLocaleLowerCase()
    ) {
      isValid = true;
    }
  }
  return isValid;
};

export const customCheckValidFileSize = (
  inputFileArray: any[],
  MAX_FILE_SIZE: number
): boolean => {
  let isValid = true;
  for (let i = 0; i < inputFileArray.length; i++) {
    const fileSizeKiloBytes = inputFileArray[i].size;
    if (fileSizeKiloBytes > MAX_FILE_SIZE) {
      isValid = false;
    }
  }
  return isValid;
};

const sanitizedData = (data: any) => ({
  __html: DOMPurify.sanitize(data),
});

/**
 * initialize script via script name and id
 * @param scriptId
 * @param scriptUrl
 */

export function initializeScript(scriptId: any, scriptUrl: any) {
  let js;
  const fjs: any = document.getElementsByTagName("script")[0];
  if (document.getElementById(scriptId)) {
    return;
  }
  js = document.createElement("script");
  js.id = scriptId;
  js.async = true;
  js.src = scriptUrl;
  fjs.parentNode.insertBefore(js, fjs);
}

export function removeScript(scriptId: any) {
  let js;
  const fjs: any = document?.getElementById(scriptId);
  fjs?.remove();
}

export const getAgentData = (ipAddress?: string) => {
  const deviceData = useDeviceData(navigator.userAgent);
  const obj = {
    [apiConstants.ipAddress]: ipAddress,
    [apiConstants.userAgent]: navigator.userAgent,
    [apiConstants.device]: "Unknown",
    [apiConstants.os]: deviceData?.os?.name,
    [apiConstants.osVersion]: deviceData?.os?.version
      ? deviceData?.os?.version
      : "Unknown",
    [apiConstants.browser]: deviceData?.browser?.name,
    [apiConstants.browserVersion]: deviceData?.browser?.version,
    [apiConstants.deviceType]:
      deviceData?.os?.name === "Android" ||
      deviceData?.os?.name === "iOS" ||
      deviceData?.os?.name === "BlackBerry"
        ? "MOBILE"
        : "DESKTOP",
  };
  return obj;
};

export const areParamsEqual = (params1: any, params2: any) => {
  // Implement your custom comparison logic here
  // For a simple shallow comparison, you can use JSON.stringify
  return JSON.stringify(params1) === JSON.stringify(params2);
};

export const getFilterKeyByApiKey = (apiKey: any) => {
  for (const key in FilterMapping) {
    if (FilterMapping[key].apiKey === apiKey) {
      return key;
    }
  }
  return ""; // Return null if no match is found
};

export const getIdFromStarting = (
  stringWithIdInFront: string
): string | number => {
  if (stringWithIdInFront) {
    const a: any[] = stringWithIdInFront?.split("-");
    if (a?.length > 0) {
      if (isNaN(a[0])) {
        return a[0];
      } else {
        return Number(a[0]);
      }
    }
  }
  return "";
};

export const isitstudentcourse = (
  stringWithIdInFront: any,
  filterInputKey: any
): any => {
  if (stringWithIdInFront) {
    const a: any[] = stringWithIdInFront?.split("-");
    if (a?.length > 0) {
      if (
        (a[1] == "ca" || a[1] == "cs" || a[1] == "cma") &&
        filterInputKey == "by_category"
      ) {
        return false;
      } else {
        return true;
      }
    }
  }
};

export const createSlugByIdName = (inputString: string): string => {
  return inputString
    .toLowerCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")
    .trim();
};

export const createCodeByName = (inputString: string): string => {
  return inputString
    .toUpperCase()
    .replace(/[^\w\s-]/g, "")
    .replace(/\s+/g, "_")
    .replace(/-+/g, "_")
    .trim();
};

export const triggerGA4Event = (
  category: string,
  action: string,
  label: string,
  value: any
) => {
  // Track a custom event
  ReactGA.event({
    category: category,
    action: action,
    label: label,
    value: value, // A numeric value (e.g., price)
    nonInteraction: false, // Whether it affects bounce rate
    transport: "beacon", // Transport method
  });
};

export const getBadgeClassByBadgeEnum = (Enum: string): string => {
  if (Enum === ProductBadgeEnum.PREORDER) {
    return "pre-order-tag";
  } else if (Enum === ProductBadgeEnum.BESTSELLER) {
    return "best-seller-tag";
  } else if (Enum === ProductBadgeEnum.POPULAR) {
    return "popular-tag";
  } else if (Enum === ProductBadgeEnum.NEWRELEASE) {
    return "new-releases-tag";
  } else if (Enum === ProductBadgeEnum.TRENDING) {
    return "trending-tag";
  }
  return "best-seller-tag";
};
export const formatDate = (date: any, format: any) => {
  return moment(date).format(format);
};

export const handlePrice = (price: any): string =>
  price?.toString().replace(/\B(?=(?:(\d\d)+(\d)(?!\d))(?!\d))/g, ",");

export const paymentType = (type: any) => {
  let text = "";
  switch (type) {
    case PaymentModes.RAZORPAY:
      text = "Online Payment";
      break;
    case PaymentModes.CHEQUE_DD:
      text = "Demand Draft/Cheque";
      break;
    case PaymentModes.NEFT:
      text = "NEFT";
      break;
    case PaymentModes.COD:
      text = "COD";
      break;
    case PaymentModes.SHOPSE:
      text = "EMI";
      break;
    case PaymentModes.RAZORPAY_RECURRING:
      text = "Online Payment";
      break;
    default:
      text = "Online Payment";
      break;
  }
  return text;
};

export function checkGSTIN(gstNumber: string): boolean | null {
  return true;
}

export const IsLoggedIn = () => {
  try {
    const jwtData: any = jwt_decode(
      getDataFromLocalStorage(LocalStorageDataModel.AUTH_TOKEN)
    );
    if (new Date().getTime() < jwtData.exp * 1000) {
      return true;
    } else {
      return false;
    }
  } catch (error) {
    return false;
  }
};

export const ScrollToTopButton = () => {
  window.scrollTo({
    top: 0,
    left: 0,
    behavior: "smooth", // Optional, adds smooth scrolling
  });
};

// export const environments: any = {
//   "development": {
//       "REACT_APP_NODE_ENV" : "development",
//       "REACT_APP_NODE_LEARNING_URL": "https://devapi.taxmann.dev/learning/api/v1",
//       "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://devapi.taxmann.dev/dashboard/api/v1/",
//       "REACT_APP_DOT_NET_BASE_URL": "https://lbackoffice.taxmann.com/taxmannapimysql/api/",
//   },
//   "staging": {
//       "REACT_APP_NODE_ENV" : "staging",
//       "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://preprodapi.taxmann.com/bookstore-dashboard/",
//       "REACT_APP_DOT_NET_BASE_URL": "https://stagingapi.taxmann.com/api/",
//   },
//   "production": {
//       "REACT_APP_NODE_ENV" : "production",
//       "REACT_APP_NODE_DASHBOARD_BASE_URL": "https://prodapibookstore.taxmann.com/bookstore-dashboard/",
//       "REACT_APP_DOT_NET_BASE_URL": "https://liveresearchapi.taxmann.com/api/",
//   }
// }
export function Env() {
  return environments[env()];
}

export function env() {
  if (window.location.hostname.indexOf("localhost") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("qa") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("dev") !== -1) {
    return "development";
  }else if (window.location.hostname.indexOf("uat") !== -1) {
    return "uat";
  } else if (window.location.hostname.indexOf("preprod") !== -1) {
    return "staging";
  } else if (window.location.hostname.indexOf("taxpractice") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("mctl") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("stag") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("lsupport") !== -1) {
    return "development";
  } else if (window.location.hostname.indexOf("vflipbook") !== -1) {
    return "development";
  } else {
    return "production";
  }
}

export const getMachineId = async () => {
  // console.log("getMachineId",getMachineId)
  if (getDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID_NEW)) {
    return Promise.resolve(true);
  } else {
    removeDataFromLocalStorage(LocalStorageDataModel.MACHINE_ID);
    return await postData(
      HOME_API_CONSTANTS.GET_MACHINE_ID,
      {},
      APIEnv.REDIS,
      "get"
    ).then((res: any) => {
      if (res?.ResponseType === APIStatus.SUCCESS) {
        if (res.Data) {
          let decryptedID: any = decrypt(res.Data);
          if (decryptedID) {
            decryptedID = JSON.parse(decryptedID);
            if (decryptedID && decryptedID.machineId) {
              setDataOnLocalStorage(
                LocalStorageDataModel.MACHINE_ID_NEW,
                decryptedID.machineId
              );
              // kept old machine id too , as it can affect the otther apps like bookstore and students
              setDataOnLocalStorage(
                LocalStorageDataModel.MACHINE_ID,
                decryptedID.machineId
              );
              return Promise.resolve(true);
            } else {
              return Promise.resolve(false);
            }
          } else {
            return Promise.resolve(false);
          }
        }
      }
    });
  }
};

export async function initializeRazorpayCheckout() {
  return await loadScript(
    // "razorpayScript",
    "https://checkout.razorpay.com/v1/checkout.js"
  );
}

export const decrypt = (ciphertext: string) => {
  let key = Env().REACT_APP_ENCODE;
  const secretKey = key.replace(/KEYGEN/g, btoa("KEYGEN"));
  var bytes = CryptoJS.AES.decrypt(ciphertext, secretKey);
  var originalText = bytes.toString(CryptoJS.enc.Utf8);
  return originalText;
};
export interface IFooterLinkModel {
  name: string;
  url: string;
  externalLink?: boolean;
  sameTab?: boolean;
  queryParams?: any;
  isHtml?: boolean;
  isNew?: boolean;
}

export const getUserIpAddress = async () => {
  return await postData(
    HOME_API_CONSTANTS.USER_IP_ADDRESS,
    { domainname: location.hostname },
    // { domainname: "https://dev.taxmann.com/" },
    APIEnv.NODE_DASHBOARD_SESSION_MANAGEMENT,
    "post"
  ).then((res: any) => {
    if (res?.ResponseType === APIStatus.SUCCESS) {
      setDataOnLocalStorage(LocalStorageDataModel.USER_IP, res?.data[0]);
      return res?.data[0];
    }
  });
};

export const loadScript = async (src: any) => {
  return new Promise((resolve, reject) => {
    const script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = (res) => resolve(res);
    script.onerror = (err) => reject(err);
    document.body.appendChild(script);
  });
};

export const formatCurrency = (amount: any, currency?: string): any => {
  return new Intl.NumberFormat("en-US", {
    // style: "currency",
    // currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
};

export const freebieColor: any = {
  BOOK: "freebie-orange",
  RESEARCH: "freebie-green",
  PRACTICE: "freebie-blue",
  JOURNAL: "freebie-orange",
  // DVD: "",
  // ADIT: "",
  // ENEWS: "",
  // EXAM: "",
  // BUNDLE: "",
  // PREMIUM: ""
};

export async function checkWidevineSupport() {
  if (isMobile()) {
    let version = getAndroidVersion();
    if (version && version > 12) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function getAndroidVersion() {
  const ua = navigator.userAgent;
  const match = ua.match(/Android\s([0-9\.]+)/);
  return match ? +match[1] : null;
}

export async function checkFairplaySupport() {
  if (isMobile()) {
    let version = getIOSVersion();
    if (version && version > 12) {
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }
}

function getIOSVersion() {
  const ua = navigator.userAgent;
  const match = ua.match(/OS (\d+)_(\d+)_?(\d+)?/);
  if (match) {
    const major = parseInt(match[1], 10);
    const minor = parseInt(match[2], 10);
    const patch = parseInt(match[3] || "0", 10);
    return major;
  }
  return null;
}

export const ipBasedUserLogin = async (ipAddress: string) => {
  const deviceData = useDeviceData(navigator.userAgent);

  const data = {
    ip_address: ipAddress,
    ipAddress: ipAddress,
    userAgent: navigator.userAgent,
    device: "Unknown",
    os: deviceData?.os?.name,
    osVersion: deviceData?.os?.version ? deviceData?.os?.version : "Unknown",
    browser: deviceData?.browser?.name,
    browserVersion: deviceData?.browser?.version,
    [apiConstants.deviceType]:
      deviceData?.os?.name === "Android" ||
      deviceData?.os?.name === "iOS" ||
      deviceData?.os?.name === "BlackBerry"
        ? "MOBILE"
        : "DESKTOP",
    category: "video",
  };

  return await postData(
    HOME_API_CONSTANTS.IP_BASED_LOGIN,
    data,
    APIEnv.NODE_DASHBOARD,
    "post"
  ).then((res: any) => {
    if (res?.ResponseType === APIStatus.SUCCESS) {
      return res?.data;
    }
  });
};

 export const getDataFromLocalStorageWithExpiry = (key:any) => {
  const itemStr = localStorage.getItem(key);
  if (!itemStr) return null;

  const item = JSON.parse(itemStr);
  const now = new Date();
  if (now.getTime() > item.expiry) {
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
};